import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { HideScrollbar, LineClamp } from '../../global/commonStyle';

const Main = styled.div`
  margin-right: -18px;
  padding-bottom: var(--space-8);
  height: calc(100vh - 127px);
  ${HideScrollbar}
`;
const Table = styled.table`
  border-bottom: 0.5px solid var(--border-primary);
  border-collapse: collapse;
  width: 100%;
  thead {
    position: sticky;
    top: 0;
    z-index: var(--z-index-base);
    background-color: var(--background-secondary);
    box-shadow: var(--bottom-border), var(--top-border);
  }
`;
const Row = styled.tr`
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const TableHeader = styled.th`
  ${Typography.body_md}
  color: var(--text-secondary);
  text-transform: uppercase;
  padding: var(--space-8);
  min-width: 200px;
  text-align: left;
  :last-child {
    border-right: 0.5px solid var(--border-primary);
  }
`;
const TableData = styled.td`
  border-right: 0.5px solid var(--border-primary);
  padding: var(--space-16) var(--space-13) var(--space-8) var(--space-8);
  height: 201px;
  min-width: 200px;
  cursor: pointer;
  vertical-align: baseline;
  &:hover {
    background-color: var(--neutral-secondary);
    .dates {
      color: var(--brand-primary);
    }
  }
`;
const Bottom = styled.tbody``;
const Data = styled.div`
  display: flex;
  gap: var(--space-8);
  flex-direction: column;
`;
const Dates = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  padding-left: var(--space-8);
  ${(props: { disabled?: boolean }) =>
    props.disabled &&
    css`
      color: var(--text-secondary);
    `}
`;
const Card = styled.div`
  min-width: 180px;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background-color: var(--background-primary);
  padding: var(--space-7);
`;

const Label = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
  ${LineClamp(2)}
  width: 100%;
  max-width: 184px;
  min-width: 180px;
`;
const Tasks = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;
const Button = styled.button`
  background-color: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  ${Typography.body_md}
  padding: var(--space-0);
  display: inline-flex;
  &:hover {
    color: var(--text-secondary);
  }
`;
export { Main, Table, Row, TableHeader, TableData, Bottom, Data, Dates, Card, Label, Tasks, Button };
